import React from 'react';
import Pagination from '../../../components/pagination';
import { format } from 'date-fns';

function FacilityTable({
  handleSort,
  onDelete,
  onSelectedData,
  paginationOptions,
  handlePageChange,
  loading,
  error,
  data,
  totalRows,
  handleRefresh
}) {
  return (
    <div className="overflow-scroll scroll-bar-1 mb-20">
      <table className="table-2 col-12">
        <thead>
          <tr>
            <th>Icon</th>
            <th className="cursor-pointer" onClick={() => handleSort('name')}>
              Nama Fasilitas
              {paginationOptions.sort_field === 'name' && (
                <span className="ml-20">
                  <i
                    className={`fa fa-caret-${paginationOptions.sort_value === 'asc' ? 'down' : 'up'} text-blue-1 fs-5`}
                  />
                </span>
              )}
            </th>
            <th className="cursor-pointer" onClick={() => handleSort('created_at')}>
              Tanggal Dibuat
              {paginationOptions.sort_field === 'created_at' && (
                <span className="ml-20">
                  <i
                    className={`fa fa-caret-${paginationOptions.sort_value === 'asc' ? 'down' : 'up'} text-blue-1 fs-5`}
                  />
                </span>
              )}
            </th>
            <th className="cursor-pointer" onClick={() => handleSort('updated_at')}>
              Update Terakhir
              {paginationOptions.sort_field === 'updated_at' && (
                <span className="ml-20">
                  <i
                    className={`fa fa-caret-${paginationOptions.sort_value === 'asc' ? 'down' : 'up'} text-blue-1 fs-5`}
                  />
                </span>
              )}
            </th>
            <th className="text-center">Aksi</th>
          </tr>
        </thead>
        <tbody>
          {loading && (
            <tr>
              <th className="text-center" colSpan="6">
                Loading data...
              </th>
            </tr>
          )}
          {!loading && data.length === 0 && !error && (
            <tr>
              <th className="text-center" colSpan="6">
                No data
              </th>
            </tr>
          )}
          {error && (
            <tr>
              <th className="text-center" colSpan="6">
                Tidak ada koneksi internet,{' '}
                <span className="text-danger cursor-pointer" onClick={handleRefresh}>
                  Coba kembali
                </span>
              </th>
            </tr>
          )}
          {data.map((row) => (
            <tr key={row.id}>
              <td>
                {row.icon && (
                  <a href={row.icon} target="_blank" rel="noreferrer">
                    <img src={row.icon} style={{ height: 50, width: 50 }} />
                  </a>
                )}
              </td>
              <td>
                <span className="fw-500">{row.name ?? '-'}</span>
              </td>
              <td>{format(new Date(row.created_at), 'dd/MM/yyyy hh:mm')}</td>
              <td>{format(new Date(row.updated_at), 'dd/MM/yyyy hh:mm')}</td>
              <td className="text-center pe-0">
                <div
                  onClick={() => onSelectedData(row)}
                  data-bs-toggle="modal"
                  data-bs-target="#updateFacilityModal"
                  className="fw-600 btn btn-success text-white btn-sm">
                  <i className="fa fa-pencil mr-4"></i>
                  Edit
                </div>
                <div
                  onClick={() => onDelete(row.id)}
                  className="fw-600 btn btn-danger text-white btn-sm ml-10">
                  <i className="fa fa-trash mr-4"></i>
                  Hapus
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      <Pagination
        currentPage={paginationOptions.page}
        totalRows={totalRows}
        rowsPerPage={paginationOptions.limit}
        onPageChange={handlePageChange}
      />
    </div>
  );
}

export default FacilityTable;
